import { useEffect, useState } from 'react'
import xlsxFile from 'read-excel-file'

export default function useExcelParse() {
    const [excelFile, setExcelFile] = useState([])
    const [excelPage, setExcelPage] = useState([])
    const [errors, setErrors] = useState([])
    const [status, setStatus] = useState('notStarted')
    const [excelData, setExcelData] = useState([])

    const handleChange = (uploadedFile) => {
        setExcelFile([])
        setExcelPage([])
        setExcelData([])
        setImportResult([])
        setExcelFile([uploadedFile])
    }
    const [importResult, setImportResult] = useState([])
    const [loading, setLoading] = useState(false)

    const getExcelPage = (file) => {
        return xlsxFile(file, { getSheets: true }).then((rows) =>
            rows.filter(({ name }) => !name.startsWith('XX')).map((el) => ({ name: el.name, fileName: file.name }))
        )
    }

    const getAllPages = async () => {
        setLoading(true)
        const pages = await Promise.all(excelFile.map((file) => getExcelPage(file)))
        pages.forEach((page) => {
            page.forEach(({ name, fileName }) => {
                setExcelPage((prev) => [...prev, { name, fileName }])
            })
        })
        setLoading(false)
    }

    useEffect(() => {
        if (excelFile?.length > 0) {
            getAllPages()
        }
    }, [excelFile])

    useEffect(() => {
        if (excelPage.length > 0) {
            setLoading(true)

            excelPage.forEach((element) => {
                xlsxFile(
                    excelFile.find((el) => el.name === element.fileName),
                    { sheet: element.name }
                ).then((rows) => {
                    const values = rows.slice(2, rows.length)
                    const _excelData = []
                    const _errors = []
                    values.forEach((col, index) => {
                        // Read values
                        const kmat = col[0]
                        const varcond = col[1]
                        const reference = col[2]
                        const quantity = col[3] ? String(col[3]).replaceAll('.', ',') : null
                        const productName = col[4]
                        const size = col[5]
                        const optionNb = col[6]
                        const type = col[7]

                        // Remove duplicates
                        const isObjectDuplicate = excelData.find(
                            (obj) =>
                                productName === obj.productName &&
                                size === obj.size &&
                                type === obj.type &&
                                kmat === obj.kmat &&
                                varcond === obj.varcond &&
                                reference === obj.reference &&
                                quantity === obj.quantity &&
                                optionNb === obj.optionNb
                        )
                        if ((kmat || varcond) && (reference || quantity)) {
                            _errors.push(
                                `Error on line ${
                                    index + 1
                                }: You cannot specify both KMAT/VARCOND and Reference. Please provide either KMAT/VARCOND OR Reference, but not both.`
                            )
                        }
                        if (!isObjectDuplicate) {
                            _excelData.push({ productName, kmat, varcond, reference, quantity, size, type, optionNb })
                        }
                    })
                    setExcelData((prev) => [...prev, ..._excelData])
                    setErrors(_errors)
                    setLoading(false)
                    setStatus('finished')
                })
            })
        }
    }, [excelPage])

    return { handleChange, importResult, loading, excelPage, excelData, status, errors }
}
